(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9275],{

/***/ 63203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_pages_v2_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(96887);
// EXTERNAL MODULE: ./src/cms/utils.ts
var utils = __webpack_require__(46000);
;// CONCATENATED MODULE: ./src/cms/navHeaderUtils.ts


function extractNavData(header) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var mainNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.mainNav) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(link) {
        // mainNav can now be ILpElementLink (simple) or ILpElementSimpleList (with sections)
        // Only extract simple links for mainNavLinks
        if (!(0,utils/* isSimpleLink */.$)(link)) return;
        if (!link.fields.text || !link.fields.url) return;
        mainNavLinks.push({
            name: link.fields.text,
            href: link.fields.url
        });
    });
    var menuPanelNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref2 = header.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.menuPanelNav) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(link) {
        if (link.fields.text && link.fields.url) {
            menuPanelNavLinks.push({
                name: link.fields.text,
                href: link.fields.url
            });
        }
    });
    var ctaTitle = header === null || header === void 0 ? void 0 : header.fields.menuPanelCtaTitle;
    var ctaLink;
    if ((header === null || header === void 0 ? void 0 : (ref4 = header.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.menuPanelCta) === null || ref5 === void 0 ? void 0 : ref5.fields.text) && (header === null || header === void 0 ? void 0 : (ref6 = header.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.menuPanelCta) === null || ref7 === void 0 ? void 0 : ref7.fields.url)) {
        ctaLink = {
            name: header.fields.menuPanelCta.fields.text,
            href: header.fields.menuPanelCta.fields.url
        };
    }
    // Transform header.mainNav (union type) into MegaNavItem[] format
    var megaNavData = (0,cms/* transformHeaderNavToMegaNav */.$C)(header === null || header === void 0 ? void 0 : (ref8 = header.fields) === null || ref8 === void 0 ? void 0 : ref8.mainNav);
    return {
        mainNavLinks: mainNavLinks,
        menuPanelNavLinks: menuPanelNavLinks,
        megaNavData: megaNavData,
        ctaTitle: ctaTitle,
        ctaLink: ctaLink
    };
}

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/components/shared/performance/preloads.ts
var preloads = __webpack_require__(59639);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(43552);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js
var IconButton = __webpack_require__(7603);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/InspectionBanner.tsx
"use client";



var GiftIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18.5 21H5.5V12H3.5V8H20.5V12H18.5V21Z",
                fill: "url(#paint0_linear_4031_637)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 8V21M12 8C11.6383 6.5094 11.0154 5.23501 10.2127 4.34311C9.41003 3.45121 8.46469 2.98314 7.5 2.99995C6.83696 2.99995 6.20107 3.26334 5.73223 3.73218C5.26339 4.20102 5 4.83691 5 5.49995C5 6.16299 5.26339 6.79887 5.73223 7.26772C6.20107 7.73656 6.83696 7.99995 7.5 7.99995M12 8C12.3617 6.5094 12.9846 5.23501 13.7873 4.34311C14.59 3.45121 15.5353 2.98314 16.5 2.99995C17.163 2.99995 17.7989 3.26334 18.2678 3.73218C18.7366 4.20102 19 4.83691 19 5.49995C19 6.16299 18.7366 6.79887 18.2678 7.26772C17.7989 7.73656 17.163 7.99995 16.5 7.99995M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12M3 9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V11C21 11.2652 20.8946 11.5196 20.7071 11.7071C20.5196 11.8946 20.2652 12 20 12H4C3.73478 12 3.48043 11.8946 3.29289 11.7071C3.10536 11.5196 3 11.2652 3 11V9Z",
                stroke: "#F9C940",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear_4031_637",
                    x1: "16",
                    y1: "9",
                    x2: "12",
                    y2: "21",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#A51C1C"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#E12020"
                        })
                    ]
                })
            })
        ]
    });
};
var BANNER_DISMISSED_KEY = "inspection-banner-dismissed";
/**
 * Promotional banner for free home inspection report offer.
 * Part of experiment: growth-25-12-inspection-banner
 *
 * Impression tracking is handled at the Cloudflare Worker level.
 *
 * Figma: https://www.figma.com/design/PRkjHWTpRlrz6YFlekrChg/?node-id=4002-2104
 */ var InspectionBanner = function() {
    var ref = (0,react.useState)(true), isDismissed = ref[0], setIsDismissed = ref[1]; // Start hidden to prevent flash
    (0,react.useEffect)(function() {
        // Check localStorage on mount
        var dismissed = localStorage.getItem(BANNER_DISMISSED_KEY) === "true";
        setIsDismissed(dismissed);
    }, []);
    var handleDismiss = function() {
        setIsDismissed(true);
        localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    };
    if (isDismissed) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "inspection-banner",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: "$3x",
        paddingHorizontal: "$4x",
        gap: "$3x",
        // Figma: #00278b (sem/color/background/state/hover/accent-brand)
        style: {
            backgroundColor: "#00278b"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                $largerThanSM: {
                    justifyContent: "center"
                },
                gap: "$2x",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexShrink: 0,
                        display: "flex",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GiftIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "white",
                        textAlign: "left",
                        $largerThanSM: {
                            textAlign: "center"
                        },
                        children: [
                            "Get a",
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                fontWeight: "$medium",
                                color: "white",
                                children: "FREE home inspection report"
                            }),
                            " ",
                            "($450 value) with your Opendoor offer"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexShrink: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                    analyticsName: "cosmos-inspection-banner-close",
                    onPress: handleDismiss,
                    size: "small",
                    variant: "inverse"
                })
            })
        ]
    });
};
/* harmony default export */ var landing_pages_v2_InspectionBanner = (InspectionBanner);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(45807);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/utils/getInitials.ts
var getInitials = __webpack_require__(566);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/utils/usePrevious.tsx
var usePrevious = __webpack_require__(60132);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(9574);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/menu/MenuPanel.tsx + 10 modules
var MenuPanel = __webpack_require__(32654);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/OpendoorLogo.tsx
var OpendoorLogo = __webpack_require__(8222);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/AccountSection.tsx + 2 modules
var AccountSection = __webpack_require__(65253);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/SkipLink.tsx
var SkipLink = __webpack_require__(50955);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/glass/constants.ts
var constants = __webpack_require__(97680);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./src/components/account/AccountMenu.tsx
var AccountMenu = __webpack_require__(43029);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassHeader.module.css
var GlassHeader_module = __webpack_require__(39730);
var GlassHeader_module_default = /*#__PURE__*/__webpack_require__.n(GlassHeader_module);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassAccountSection.tsx







var GlassAccountSection = function(param) {
    var isLoggedIn = param.isLoggedIn, showLogin = param.showLogin, initials = param.initials;
    var ref = (0,observability/* useObservability */.C3)(), trackEvent = ref.trackEvent, trackJourneyEvent = ref.trackJourneyEvent;
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setExpanded = ref1[1];
    var containerRef = (0,react.useRef)(null);
    var toggleDropdown = (0,react.useCallback)(function() {
        return setExpanded(function(prev) {
            return !prev;
        });
    }, []);
    var closeDropdown = (0,react.useCallback)(function() {
        return setExpanded(false);
    }, []);
    (0,react.useEffect)(function() {
        if (!isExpanded) return;
        var handleClickOutside = function(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                closeDropdown();
            }
        };
        var handleEscape = function(event) {
            if (event.key === "Escape") closeDropdown();
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscape);
        };
    }, [
        isExpanded,
        closeDropdown
    ]);
    var handleAvatarPress = (0,react.useCallback)(function() {
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
        trackJourneyEvent("platform", "buttonClickEvent", {
            targetName: "user-account-menu-click"
        });
        toggleDropdown();
    }, [
        trackEvent,
        trackJourneyEvent,
        toggleDropdown
    ]);
    var handleLoginPress = (0,react.useCallback)(function() {
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
        trackJourneyEvent("platform", "buttonClickEvent", {
            targetName: "account-section-click"
        });
        (0,constants/* redirectToLogin */.rf)();
    }, [
        trackEvent,
        trackJourneyEvent
    ]);
    if (isLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            ref: containerRef,
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: "$3",
            $smallerThanMD: {
                display: "none"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                    onPress: handleAvatarPress,
                    analyticsName: "cosmos-glass-nav-account",
                    "aria-label": "User account menu",
                    "aria-haspopup": "true",
                    "aria-expanded": isExpanded,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "$8",
                        height: "$8",
                        borderRadius: "$full",
                        "$platform-web": {
                            background: "rgba(255, 255, 255, 0.2)"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$labelSmall",
                            fontWeight: "$medium",
                            color: "white",
                            children: initials
                        })
                    })
                }),
                largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountMenu/* default */.Z, {
                    isExpanded: isExpanded,
                    isLoggedIn: isLoggedIn
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
        alignItems: "center",
        gap: "$3",
        $smallerThanMD: {
            display: "none"
        },
        ml: "$12",
        children: showLogin && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
            onPress: handleLoginPress,
            analyticsName: "cosmos-glass-nav-signin",
            "aria-label": "Sign in to your account",
            borderRadius: "$6x",
            cursor: "pointer",
            backgroundColor: "$transparent",
            style: {
                color: (0,cjs.getToken)("$contentInversePrimary", "color"),
                border: "1px solid ".concat((0,cjs.getToken)("$contentInversePrimary", "color"))
            },
            className: (GlassHeader_module_default()).signInButton,
            "$platform-web": {
                paddingBlock: "9.5px",
                paddingInline: "17.5px",
                letterSpacing: "-0.22px",
                textDecorationLine: "none"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$labelMedium",
                style: {
                    color: "inherit"
                },
                children: "Sign in"
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(37122);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 142 modules
var motion = __webpack_require__(94796);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassMegaNavFlyout.tsx






var flyoutVariants = {
    hidden: {
        opacity: 0,
        y: -8,
        transition: {
            duration: 0.2,
            ease: "easeOut"
        }
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.2,
            ease: "easeOut"
        }
    }
};
var GlassMegaNavFlyout = function(param) {
    var item = param.item;
    var ref, ref1;
    var isVisible = item !== null;
    var ref2 = (0,react.useState)(false), isAnimationComplete = ref2[0], setIsAnimationComplete = ref2[1];
    var flyoutRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!isVisible) {
            setIsAnimationComplete(false);
        }
    }, [
        isVisible
    ]);
    var handleAnimationComplete = (0,react.useCallback)(function(definition) {
        if (definition === "visible") {
            var ref;
            setIsAnimationComplete(true);
            var firstLink = (ref = flyoutRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("a");
            firstLink === null || firstLink === void 0 ? void 0 : firstLink.focus();
        }
    }, []);
    var handleKeyDown = (0,react.useCallback)(function(e) {
        var ref;
        var links = (ref = flyoutRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a");
        if (!(links === null || links === void 0 ? void 0 : links.length)) {
            return;
        }
        var currentIndex = Array.from(links).indexOf(document.activeElement);
        if (e.key === "ArrowDown") {
            e.preventDefault();
            var next = currentIndex < links.length - 1 ? currentIndex + 1 : 0;
            links[next].focus();
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            var prev = currentIndex > 0 ? currentIndex - 1 : links.length - 1;
            links[prev].focus();
        }
    }, []);
    var ref3;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
        ref: flyoutRef,
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        variants: flyoutVariants,
        onAnimationComplete: handleAnimationComplete,
        onKeyDown: handleKeyDown,
        role: "menu",
        "aria-label": item ? "".concat(item.name, " submenu") : undefined,
        style: {
            position: "fixed",
            top: "".concat(constants/* GLASS_HEADER_HEIGHT */.$C, "px"),
            left: 0,
            right: 0,
            borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
            zIndex: 1000,
            visibility: isVisible ? "visible" : "hidden"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            width: "100%",
            backgroundColor: "$backgroundInversePureBlack",
            pointerEvents: isVisible && isAnimationComplete ? "auto" : "none",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                maxWidth: "$328",
                px: "$5",
                pt: "$10",
                pb: "$11",
                mx: "auto",
                gap: "$45",
                "$platform-web": {
                    display: "grid",
                    gridTemplateColumns: "repeat(".concat((ref3 = item === null || item === void 0 ? void 0 : (ref = item.sections) === null || ref === void 0 ? void 0 : ref.length) !== null && ref3 !== void 0 ? ref3 : 1, ", 1fr)")
                },
                children: item === null || item === void 0 ? void 0 : (ref1 = item.sections) === null || ref1 === void 0 ? void 0 : ref1.map(function(section, sectionIndex) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                tag: "p",
                                display: "block",
                                mb: "$1half",
                                "$platform-web": {
                                    letterSpacing: "-0.22px"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$labelMedium",
                                    color: "$contentStateInactiveAccentBrand",
                                    children: section.title
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                gap: "$2",
                                mt: "$4",
                                children: section.links.map(function(link, linkIndex) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: link.href,
                                        textDecorationLine: "none",
                                        display: "block",
                                        role: "menuitem",
                                        "aria-label": "Navigate to ".concat(link.name),
                                        analyticsName: "cosmos-glass-nav-".concat(item.name.toLowerCase(), "-").concat(link.name.toLowerCase().replace(/\s+/g, "-")),
                                        className: (GlassHeader_module_default()).flyoutLink,
                                        style: {
                                            "--glass-flyout-hover-color": (0,cjs.getToken)("$contentInversePrimary", "color")
                                        },
                                        "$platform-web": {
                                            transition: "color 0.15s"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "span",
                                            typography: "$bodyMedium",
                                            color: "white",
                                            opacity: 0.75,
                                            "$platform-web": {
                                                transition: "opacity 0.15s"
                                            },
                                            hoverStyle: {
                                                opacity: 1
                                            },
                                            children: link.name
                                        })
                                    }, linkIndex);
                                })
                            })
                        ]
                    }, sectionIndex);
                })
            })
        })
    });
};
/* harmony default export */ var glass_GlassMegaNavFlyout = (GlassMegaNavFlyout);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassNavLink.tsx





var GlassNavLink = function(param) {
    var name = param.name, href = param.href, hasDropdown = param.hasDropdown, isOpen = param.isOpen, active = param.active, onPress = param.onPress;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
        href: hasDropdown ? undefined : href,
        onPress: onPress,
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        height: constants/* GLASS_HEADER_HEIGHT */.$C,
        py: "$2",
        px: "$3",
        gap: "$half",
        cursor: "pointer",
        borderRadius: "$6x",
        borderWidth: 0,
        "aria-label": hasDropdown ? "".concat(name, " menu") : "View ".concat(name),
        "aria-current": active ? "page" : undefined,
        "aria-expanded": hasDropdown ? isOpen : undefined,
        "aria-haspopup": hasDropdown ? "true" : undefined,
        analyticsName: "cosmos-glass-nav-link-".concat(name.toLowerCase()),
        className: (GlassHeader_module_default()).navLink,
        style: {
            background: isOpen ? "rgba(0, 0, 0, 0.2)" : "transparent",
            color: isOpen ? constants/* GLASS_NAV_ACTIVE_COLOR */.Iu : (0,cjs.getToken)("$contentInversePrimary", "color"),
            "--glass-nav-hover-color": isOpen ? constants/* GLASS_NAV_ACTIVE_COLOR */.Iu : "rgba(255, 255, 255, 0.7)"
        },
        "$platform-web": {
            letterSpacing: "-0.22px",
            transition: "color 0.2s, background 0.2s",
            textDecorationLine: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$labelMedium",
                style: {
                    color: "inherit"
                },
                children: name
            }),
            hasDropdown && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                alignItems: "center",
                justifyContent: "center",
                width: "$6",
                height: "$6",
                opacity: isOpen ? 1 : 0.6,
                hoverStyle: {
                    opacity: 0.9
                },
                "$platform-web": {
                    transition: "transform 0.25s, opacity 0.2s",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("polyline", {
                        points: "6 9 12 15 18 9"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassMegaNav.tsx





var GlassMegaNav = function(param) {
    var slug = param.slug, megaNavData = param.megaNavData, onOpenChange = param.onOpenChange;
    var ref = (0,react.useState)(null), openNavItem = ref[0], setOpenNavItem = ref[1];
    var navRef = (0,react.useRef)(null);
    var openerRef = (0,react.useRef)(null);
    var handleToggle = (0,react.useCallback)(function(itemName) {
        var next = openNavItem === itemName ? null : itemName;
        if (next !== null) {
            openerRef.current = document.activeElement;
        } else {
            openerRef.current = null;
        }
        setOpenNavItem(next);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(next);
    }, [
        openNavItem,
        onOpenChange
    ]);
    var handleClose = (0,react.useCallback)(function() {
        var ref;
        setOpenNavItem(null);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(null);
        (ref = openerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        openerRef.current = null;
    }, [
        onOpenChange
    ]);
    (0,react.useEffect)(function() {
        if (!openNavItem) return;
        var handleClickOutside = function(event) {
            if (navRef.current && !navRef.current.contains(event.target)) {
                handleClose();
            }
        };
        var handleEscape = function(event) {
            if (event.key === "Escape") {
                handleClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscape);
        };
    }, [
        openNavItem,
        handleClose
    ]);
    var activeItem = (0,react.useMemo)(function() {
        return megaNavData === null || megaNavData === void 0 ? void 0 : megaNavData.find(function(item) {
            var ref;
            return item.name === openNavItem && ((ref = item.sections) === null || ref === void 0 ? void 0 : ref.length);
        });
    }, [
        megaNavData,
        openNavItem
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        display: "block",
        ref: navRef,
        position: "relative",
        "$platform-web": {
            gridColumn: "2 / 3",
            gridRow: "1 / 2"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                m: "$0",
                tag: "ul",
                $smallerThanMD: {
                    display: "none"
                },
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "$1half",
                analyticsName: "cosmos-glass-nav-menu-list",
                width: "100%",
                "$platform-web": {
                    listStyleType: "none"
                },
                children: megaNavData === null || megaNavData === void 0 ? void 0 : megaNavData.map(function(navItem) {
                    var hasSections = navItem.sections && navItem.sections.length > 0;
                    var isOpen = openNavItem === navItem.name;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: "li",
                        display: "block",
                        position: "relative",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlassNavLink, {
                            name: navItem.name,
                            href: navItem.href,
                            hasDropdown: hasSections,
                            isOpen: isOpen,
                            active: slug === navItem.href,
                            onPress: hasSections ? function() {
                                return handleToggle(navItem.name);
                            } : undefined
                        })
                    }, navItem.name);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(glass_GlassMegaNavFlyout, {
                item: activeItem !== null && activeItem !== void 0 ? activeItem : null
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconSearch.mjs
var IconSearch = __webpack_require__(13129);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconChevronLeft.mjs
var IconChevronLeft = __webpack_require__(48135);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassNavSearch.tsx





var SearchIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconSearch/* default */.Z, {
            size: 18,
            color: (0,cjs.getToken)("$contentTertiary", "color"),
            stroke: 2
        })
    });
};
var DesktopNavSearch = function(param) {
    var isVisible = param.isVisible;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "flex",
        alignItems: "center",
        mx: "$3",
        my: "$1half",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        maxWidth: isVisible ? "$120" : "$0",
        "$platform-web": {
            transition: "opacity 0.3s, max-width 0.4s"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            flex: 1,
            minWidth: 0,
            ml: "$2",
            width: "100%",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                hideLabel: true,
                inputLocation: "hero-cta",
                analyticsPrefix: "cosmos-glass-nav-search-desktop",
                trackingTaxonomy: "new_homepage",
                placeholder: "Enter home address",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchIcon, {}),
                size: "xsmall"
            })
        })
    });
};
var MobileNavSearch = function(param) {
    var isVisible = param.isVisible, onExpandChange = param.onExpandChange;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var containerRef = (0,react.useRef)(null);
    var collapseRafRef = (0,react.useRef)(0);
    var closeButtonRef = (0,react.useRef)(null);
    var expand = (0,react.useCallback)(function() {
        if (true) {
            cancelAnimationFrame(collapseRafRef.current);
        }
        setIsExpanded(true);
        onExpandChange === null || onExpandChange === void 0 ? void 0 : onExpandChange(true);
    }, [
        onExpandChange
    ]);
    var collapseIfBlurred = (0,react.useCallback)(function() {
        if (false) {}
        collapseRafRef.current = requestAnimationFrame(function() {
            var ref;
            var active = document.activeElement;
            if (containerRef.current && !containerRef.current.contains(active) && !((ref = closeButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(active))) {
                setIsExpanded(false);
                onExpandChange === null || onExpandChange === void 0 ? void 0 : onExpandChange(false);
            }
        });
    }, [
        onExpandChange
    ]);
    var collapseExplicitly = (0,react.useCallback)(function() {
        if (true) {
            cancelAnimationFrame(collapseRafRef.current);
        }
        setIsExpanded(false);
        onExpandChange === null || onExpandChange === void 0 ? void 0 : onExpandChange(false);
    }, [
        onExpandChange
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (collapseRafRef.current) {
                cancelAnimationFrame(collapseRafRef.current);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        alignItems: "center",
        width: "100%",
        gap: "$2",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        "$platform-web": {
            transition: "opacity 0.3s ease"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                ref: closeButtonRef,
                "aria-label": "Close search",
                "aria-hidden": !isExpanded,
                tabIndex: isExpanded ? 0 : -1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                height: "$11",
                backgroundColor: "$transparent",
                cursor: "pointer",
                analyticsName: "cosmos-glass-nav-search-close",
                onPress: collapseExplicitly,
                borderWidth: 0,
                p: "$0",
                overflow: "hidden",
                width: isExpanded ? "$7" : "$0",
                opacity: isExpanded ? 1 : 0,
                "$platform-web": {
                    transition: "width 0.2s ease, opacity 0.2s ease"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronLeft/* default */.Z, {
                    size: 22,
                    color: (0,cjs.getToken)("$contentPrimary", "color")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                ref: containerRef,
                flex: 1,
                minWidth: 0,
                onFocus: expand,
                onBlur: collapseIfBlurred,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                    hideLabel: true,
                    inputLocation: "hero-cta",
                    analyticsPrefix: "cosmos-glass-nav-search-mobile",
                    trackingTaxonomy: "new_homepage",
                    placeholder: "Enter home address",
                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchIcon, {}),
                    size: "xsmall"
                })
            })
        ]
    });
};
var GlassNavSearch = function(param) {
    var isVisible = param.isVisible, onExpandChange = param.onExpandChange;
    if (onExpandChange) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavSearch, {
            isVisible: isVisible,
            onExpandChange: onExpandChange
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavSearch, {
        isVisible: isVisible
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/glass/GlassHeader.tsx



















var GlassHeader = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaTitle = param.ctaTitle, ctaLink = param.ctaLink, megaNavData = param.megaNavData;
    var pathname = (0,next_router.useRouter)().pathname;
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    var ref = (0,auth_fe_esm/* useAuth */.aC)(), human = ref.user, authentication = ref.authentication;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var isLoggedIn = authentication.state === "authenticated";
    var initials = (0,getInitials/* getInitials */.Q)(human === null || human === void 0 ? void 0 : human.fullName, human === null || human === void 0 ? void 0 : human.firstName);
    var showLogin = !(pathname.includes("/login") || pathname.includes("/account"));
    var ref1 = (0,react.useState)(false), isScrolled = ref1[0], setIsScrolled = ref1[1];
    var ref2 = (0,react.useState)(false), isAddressHidden = ref2[0], setIsAddressHidden = ref2[1];
    var ref3 = (0,react.useState)(false), isMenuOpen = ref3[0], setIsMenuOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isMobileMenuOpen = ref4[0], setIsMobileMenuOpen = ref4[1];
    var ref5 = (0,react.useState)(false), isMobileSearchExpanded = ref5[0], setIsMobileSearchExpanded = ref5[1];
    var prevMobileMenuOpen = (0,usePrevious/* default */.Z)(isMobileMenuOpen);
    var observerRef = (0,react.useRef)(null);
    var addressObserverRef = (0,react.useRef)(null);
    var hamburgerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (false) {}
        var scrollHandler = null;
        var mutationObserver = null;
        var rootMargin = "-".concat(constants/* GLASS_HEADER_HEIGHT */.$C, "px 0px 0px 0px");
        var observeHero = function(el) {
            var ref;
            (ref = observerRef.current) === null || ref === void 0 ? void 0 : ref.disconnect();
            observerRef.current = new IntersectionObserver(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
                return setIsScrolled(!entry.isIntersecting);
            }, {
                threshold: 0,
                rootMargin: rootMargin
            });
            observerRef.current.observe(el);
            if (scrollHandler) {
                window.removeEventListener("scroll", scrollHandler);
                scrollHandler = null;
            }
        };
        var observeAddress = function(el) {
            var ref;
            (ref = addressObserverRef.current) === null || ref === void 0 ? void 0 : ref.disconnect();
            addressObserverRef.current = new IntersectionObserver(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
                return setIsAddressHidden(!entry.isIntersecting);
            }, {
                threshold: 0,
                rootMargin: rootMargin
            });
            addressObserverRef.current.observe(el);
        };
        var heroSelector = "[data-hero]";
        var addressSelector = '[class*="hp-reskin-v2-address-entry-wrapper"],.hp-reskin-v2-address-entry-wrapper';
        var tryObserve = function() {
            var heroEl = document.querySelector(heroSelector);
            if (heroEl) observeHero(heroEl);
            var addressEl = document.querySelector(addressSelector);
            if (addressEl) observeAddress(addressEl);
            return {
                heroFound: !!heroEl,
                addressFound: !!addressEl
            };
        };
        var ref = tryObserve(), heroFound = ref.heroFound, addressFound = ref.addressFound;
        if (!heroFound) {
            scrollHandler = function() {
                return setIsScrolled(window.scrollY > constants/* GLASS_HEADER_HEIGHT */.$C);
            };
            window.addEventListener("scroll", scrollHandler, {
                passive: true
            });
        }
        if (!heroFound || !addressFound) {
            mutationObserver = new MutationObserver(function() {
                var result = tryObserve();
                if (result.heroFound && result.addressFound) {
                    mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
                }
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        return function() {
            var ref, ref1;
            (ref = observerRef.current) === null || ref === void 0 ? void 0 : ref.disconnect();
            (ref1 = addressObserverRef.current) === null || ref1 === void 0 ? void 0 : ref1.disconnect();
            mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
            if (scrollHandler) {
                window.removeEventListener("scroll", scrollHandler);
            }
        };
    }, []);
    var handleMenuOpenChange = (0,react.useCallback)(function(itemName) {
        setIsMenuOpen(itemName !== null);
    }, []);
    var handleMobileSearchExpandChange = (0,react.useCallback)(function(expanded) {
        setIsMobileSearchExpanded(expanded);
    }, []);
    var toggleMobileMenu = (0,react.useCallback)(function() {
        setIsMobileMenuOpen(function(prev) {
            return !prev;
        });
    }, []);
    var trackMenuClick = (0,react.useCallback)(function() {
        trackEvent("cta-click", "menu", undefined, {
            categoryOverride: "homepage"
        });
    }, [
        trackEvent
    ]);
    var trackAccountClick = (0,react.useCallback)(function() {
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
    }, [
        trackEvent
    ]);
    var exitComplete = function() {
        if (prevMobileMenuOpen === true) {
            var activeEl = document.activeElement;
            var isInputFocused = (0,_instanceof/* default */.Z)(activeEl, HTMLInputElement) || (0,_instanceof/* default */.Z)(activeEl, HTMLTextAreaElement);
            if (!isInputFocused) {
                var ref;
                (ref = hamburgerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        }
    };
    (0,react.useEffect)(function() {
        if (largerThanSM && isMobileMenuOpen) {
            setIsMobileMenuOpen(false);
        }
    }, [
        largerThanSM,
        isMobileMenuOpen
    ]);
    var anyMenuOpen = isMenuOpen || isMobileMenuOpen;
    var bgValue = "transparent";
    if (anyMenuOpen) {
        bgValue = "rgba(0, 0, 0, 1)";
    } else if (isScrolled) {
        bgValue = "rgba(0, 0, 0, 0.85)";
    }
    var blurValue = isScrolled && !anyMenuOpen ? "blur(12px)" : "blur(3.5px)";
    var mobileWhiteHeader = isScrolled;
    var mobileFg = mobileWhiteHeader ? (0,cjs.getToken)("$contentPrimary", "color") : (0,cjs.getToken)("$contentInversePrimary", "color");
    var mobileBg = mobileWhiteHeader ? "#ffffff" : "transparent";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPanel/* default */.Z, {
                slug: slug,
                menuPanelNavLinks: menuPanelNavLinks,
                mainNavLinks: mainNavLinks,
                ctaTitle: ctaTitle,
                ctaLink: ctaLink,
                isVisible: isMobileMenuOpen,
                setIsVisible: setIsMobileMenuOpen,
                exitComplete: exitComplete,
                megaNavData: megaNavData,
                variant: "glass"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "block",
                zIndex: 2000,
                height: constants/* GLASS_HEADER_HEIGHT */.$C,
                top: 0,
                left: 0,
                right: 0,
                width: "100%",
                "$platform-web": {
                    position: "fixed"
                },
                borderRadius: 0,
                overflow: "visible",
                $smallerThanMD: {
                    overflow: "visible"
                },
                className: (GlassHeader_module_default()).headerBar,
                style: {
                    border: "none",
                    "--glass-header-bg": bgValue,
                    "--glass-header-blur": blurValue,
                    "--glass-header-mobile-bg": mobileBg,
                    "--glass-header-mobile-border": mobileWhiteHeader ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.08)"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: constants/* GLASS_HEADER_HEIGHT */.$C,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        width: "100%",
                        height: constants/* GLASS_HEADER_HEIGHT */.$C,
                        maxWidth: "$328",
                        px: "$5",
                        alignItems: "center",
                        "$platform-web": {
                            display: "grid",
                            gridTemplateColumns: "auto 1fr auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkipLink/* SkipLink */.G, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                alignItems: "center",
                                pr: "$2",
                                zIndex: 5,
                                gridColumn: "1 / 2",
                                gridRow: "1 / 2",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: "/",
                                        analyticsName: "cosmos-glass-nav-logo",
                                        "aria-label": "Go to Home page",
                                        display: "flex",
                                        alignItems: "center",
                                        color: "$contentInversePrimary",
                                        $smallerThanMD: {
                                            display: "none"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpendoorLogo/* OpendoorLogo */.o, {
                                            width: "96px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: "/",
                                        analyticsName: "cosmos-glass-nav-logo",
                                        "aria-label": "Go to Home page",
                                        display: isMobileSearchExpanded ? "none" : "flex",
                                        alignItems: "center",
                                        color: mobileFg,
                                        $largerThanSM: {
                                            display: "none"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpendoorLogo/* OpendoorLogoBadge */.j, {})
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        $smallerThanMD: {
                                            display: "none"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlassNavSearch, {
                                            isVisible: isAddressHidden
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlassMegaNav, {
                                slug: slug,
                                megaNavData: megaNavData,
                                onOpenChange: handleMenuOpenChange
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                $largerThanSM: {
                                    display: "none"
                                },
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                                minWidth: 0,
                                px: "$1",
                                "$platform-web": {
                                    gridColumn: "2 / 3",
                                    gridRow: "1 / 2"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlassNavSearch, {
                                    isVisible: isAddressHidden && !isMobileMenuOpen,
                                    onExpandChange: handleMobileSearchExpandChange
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                display: "flex",
                                alignItems: "center",
                                gap: "$4",
                                flexShrink: 0,
                                "$platform-web": {
                                    gridRow: "1 / 2",
                                    gridColumn: "-1 / -2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlassAccountSection, {
                                        isLoggedIn: isLoggedIn,
                                        showLogin: showLogin,
                                        initials: initials
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        $largerThanSM: {
                                            display: "none"
                                        },
                                        display: isMobileSearchExpanded ? "none" : "flex",
                                        ml: "$2",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountSection/* AccountSection */.d, {
                                            isLoggedIn: isLoggedIn,
                                            showLogin: showLogin,
                                            initials: initials,
                                            redirectToLogin: constants/* redirectToLogin */.rf,
                                            trackAccountClick: trackAccountClick,
                                            trackMenuClick: trackMenuClick,
                                            onMobileMenuToggle: toggleMobileMenu,
                                            isMobileMenuVisible: isMobileMenuOpen,
                                            hamburgerRef: hamburgerRef,
                                            foregroundColor: mobileFg
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var glass_GlassHeader = (GlassHeader);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 3 modules
var Header = __webpack_require__(32681);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/useInspectionBannerExperiment.ts


var INSPECTION_BANNER_EXPERIMENT_KEY = "growth-25-12-inspection-banner";
/**
 * LocalStorage key for storing the experiment variant.
 * This allows us to pass the variant to the backend when creating a seller input
 * so it can be stored on the lead for Iterable attribution.
 */ var INSPECTION_BANNER_VARIANT_STORAGE_KEY = "inspection-banner-experiment-variant";
/**
 * Get the stored inspection banner experiment variant from localStorage.
 * This can be used when creating a seller input to pass the variant to the backend
 * for Iterable attribution tracking.
 */ function getStoredInspectionBannerVariant() {
    if (false) {}
    var stored = localStorage.getItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY);
    if (stored === "treatment" || stored === "control") {
        return stored;
    }
    return null;
}
/**
 * Hook to get the inspection banner experiment variant from query params.
 * Returns 'treatment' to show the banner, 'control' for no banner,
 * or null while loading.
 *
 * The variant is bucketed at the Cloudflare Worker level using Amplitude local evaluation
 * and passed to Cosmos via the `inspection_banner_variant` query param.
 * Impression tracking is handled automatically by the CF Worker.
 *
 * The variant is also stored in localStorage so it can be passed to the backend
 * when creating a seller input for Iterable attribution tracking.
 */ function useInspectionBannerExperiment() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), variant = ref[0], setVariant = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        // Wait for router to be ready (query params populated)
        if (!router.isReady) {
            return;
        }
        // Read variant from query param (set by Cloudflare Worker)
        var queryVariant = router.query.inspection_banner_variant;
        var resolvedVariant = queryVariant === "treatment" ? "treatment" : "control";
        setVariant(resolvedVariant);
        setIsLoading(false);
        // Store variant in localStorage for backend attribution
        localStorage.setItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY, resolvedVariant);
    }, [
        router.isReady,
        router.query.inspection_banner_variant
    ]);
    return {
        variant: variant,
        isLoading: isLoading
    };
}

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(60179);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/VisitorModal.tsx




var GetCashOfferModal = function(entry) {
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        if (authentication.state === "not_authenticated") {
            var hasShownDialog = localStorage.getItem("getCashOfferModalShown");
            if (!hasShownDialog) {
                timer = setTimeout(function() {
                    setIsOpen(true);
                    localStorage.setItem("getCashOfferModalShown", "true");
                }, 400);
            }
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        authentication.state
    ]);
    var handleClose = function() {
        setIsOpen(!isOpen);
    };
    var analyticsName = "cosmos-landing-page-visitor-modal-".concat(entry === null || entry === void 0 ? void 0 : entry.analyticsId);
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        isOpen: isOpen,
        dismissable: largerThanSM ? true : false,
        animation: "accelerateDecelerateFast",
        setIsOpen: handleClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            maxWidth: 504,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                title: entry.title,
                titleProps: {
                    typography: "$subheaderLarge",
                    $largerThanSM: {
                        typography: "$headerLarge"
                    }
                },
                description: entry.description,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    $largerThanSM: {
                        pt: "$24x"
                    },
                    pt: "$16x",
                    children: [
                        !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            variant: "secondary",
                            size: "small",
                            analyticsName: analyticsName,
                            label: "Close",
                            onPress: handleClose
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            marginTop: "$4x",
                            variant: "primary",
                            size: "small",
                            $largerThanSM: {
                                size: "medium"
                            },
                            onPress: function() {
                                document.location.href = "https://www.opendoor.com/address-entry";
                            },
                            analyticsName: "".concat(analyticsName, "-cash-offer-cta"),
                            label: "Get a cash offer"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var VisitorModal = (GetCashOfferModal);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/Layout.tsx













var MaintenanceBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 716).then(__webpack_require__.bind(__webpack_require__, 40716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40716)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1243).then(__webpack_require__.bind(__webpack_require__, 71243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71243)
            ];
        }
    }
});
var Layout = function(param) {
    var header = param.header, slug = param.slug, footer = param.footer, extraLegalText = param.extraLegalText, showEligibilityLegal = param.showEligibilityLegal, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal, showPromotionLegal = param.showPromotionLegal, children = param.children, showModal = param.showModal, modalTitle = param.modalTitle, modalDescription = param.modalDescription, modalAnalyticsId = param.modalAnalyticsId, hideHeader = param.hideHeader, hideFooter = param.hideFooter, headerVariant = param.headerVariant;
    var resolvedHeaderVariant = headerVariant !== null && headerVariant !== void 0 ? headerVariant : null;
    var useGlassHeader = resolvedHeaderVariant === "treatment";
    var ref = useInspectionBannerExperiment(), inspectionBannerVariant = ref.variant;
    // Only show inspection banner on homepage variants for treatment group
    // Matches: '/', '/homepage-kt', '/homepage-v2', '/landing-pages-v2/homepage-kt', etc.
    var isHomepage = slug === "/" || slug.toLowerCase().includes("homepage");
    var showInspectionBanner = isHomepage && inspectionBannerVariant === "treatment";
    var navData = extractNavData(header);
    var mainNavLinks = navData.mainNavLinks, menuPanelNavLinks = navData.menuPanelNavLinks, megaNavData = navData.megaNavData, ctaTitle = navData.ctaTitle, ctaLink = navData.ctaLink;
    var getOfferExperiment = (0,queryParams/* default */.Z)().getOfferExperiment;
    var showGetCashOfferModal = showModal && getOfferExperiment === "treatment";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    preloads/* CONTENT_PAGE_FONT_PRELOADS.map */.v.map(function(preload) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                            rel: "preload",
                            href: preload.href,
                            as: preload.as,
                            type: preload.type,
                            crossOrigin: preload.crossOrigin
                        }, preload.href);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaintenanceBanner, {}),
            showInspectionBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_InspectionBanner, {}),
            showGetCashOfferModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VisitorModal, {
                title: modalTitle,
                description: modalDescription,
                analyticsId: modalAnalyticsId
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                display: "block",
                children: [
                    !hideHeader && (useGlassHeader ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(glass_GlassHeader, {
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        ctaTitle: ctaTitle,
                        ctaLink: ctaLink,
                        slug: slug,
                        megaNavData: megaNavData
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        ctaTitle: ctaTitle,
                        ctaLink: ctaLink,
                        slug: slug,
                        megaNavData: megaNavData
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            width: "100%",
                            m: "$0",
                            display: "block",
                            children: [
                                children,
                                !hideFooter && footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                                    siteFooter: footer,
                                    extraLegalText: extraLegalText,
                                    showCustomerTestimonialLegal: showCustomerTestimonialLegal,
                                    showEligibilityLegal: showEligibilityLegal,
                                    showPromotionLegal: showPromotionLegal,
                                    showThePdpCopyrightLegal: showThePdpCopyrightLegal
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var landing_pages_v2_Layout = (Layout);


/***/ }),

/***/ 59639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getContentPageImagePreloads; },
/* harmony export */   "v": function() { return /* binding */ CONTENT_PAGE_FONT_PRELOADS; }
/* harmony export */ });
var CONTENT_PAGE_FONT_PRELOADS = [
    {
        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
        as: "font",
        type: "font/woff2",
        crossOrigin: "anonymous"
    },
    {
        href: "/fonts/graphik-medium/Graphik-Medium.woff2",
        as: "font",
        type: "font/woff2",
        crossOrigin: "anonymous"
    },
    {
        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
        as: "font",
        type: "font/woff2",
        crossOrigin: "anonymous"
    }, 
];
var isPictureSource = function(value) {
    if (!value || typeof value !== "object") return false;
    var source = value;
    return typeof source.key === "string" && typeof source.srcSet === "string" && typeof source.media === "string" && (source.fallbackSrc === undefined || typeof source.fallbackSrc === "string");
};
var getContentPageImagePreloads = function(idToLoaderData) {
    return Object.values(idToLoaderData).flatMap(function(loaderData) {
        return Array.isArray(loaderData === null || loaderData === void 0 ? void 0 : loaderData.preloadImages) ? loaderData.preloadImages : [];
    }).filter(isPictureSource);
};


/***/ }),

/***/ 17919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useOnLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// Periodically we want to load something after the window has loaded. This will
// do that, it also adds a buffer so it's definitely "afterLoad", these are for
// low-priority things.
var useOnLoad = function() {
    var onLoadStateChange = function onLoadStateChange() {
        setTimeout(function() {
            return setIsAfterLoad(true);
        }, 1000);
    };
    var handleLoadStateCleanup = function handleLoadStateCleanup() {
        window.removeEventListener("load", onLoadStateChange);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(// handle ssr
    typeof document === "undefined" ? false : document.readyState === "complete"), isAfterLoad = ref[0], setIsAfterLoad = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAfterLoad) {
            handleLoadStateCleanup();
            return;
        }
        window.addEventListener("load", onLoadStateChange);
        return handleLoadStateCleanup;
    }, [
        isAfterLoad
    ]);
    return isAfterLoad;
};


/***/ }),

/***/ 39275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shared_LandingPageV2Layout; },
  "getJobPostingSchemaFromLoaderData": function() { return /* binding */ getJobPostingSchemaFromLoaderData; },
  "getLandingpageV2ServerSideProps": function() { return /* binding */ getLandingpageV2ServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/build/faviconPath.js
var faviconPath = __webpack_require__(71390);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(96887);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Layout.tsx + 10 modules
var Layout = __webpack_require__(63203);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/glass/constants.ts
var constants = __webpack_require__(97680);
// EXTERNAL MODULE: ./src/components/shared/performance/preloads.ts
var preloads = __webpack_require__(59639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(45807);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(9574);
// EXTERNAL MODULE: ./src/components/shared/useOnLoad.ts
var useOnLoad = __webpack_require__(17919);
;// CONCATENATED MODULE: ./src/components/shared/usePromptGoogleOneTap.ts




/**
 * Prompt the user to sign in with Google One Tap with built in error tracking + analytics
 * @param page - The page name to use for analytics tracking
 */ var usePromptGoogleOneTap = function(page, onSuccess, disablePromptGoogleOneTap, delay) {
    var ref = (0,observability/* useObservability */.C3)(), trackEvent = ref.trackEvent, trackError = ref.trackError;
    var ref1 = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref1.authentication, refresh = ref1.refresh;
    var isAfterLoad = (0,useOnLoad/* useOnLoad */.g)();
    (0,react.useEffect)(function() {
        // don't fire off the import until the document is finished loading
        if (authentication.state !== "not_authenticated" || !isAfterLoad || disablePromptGoogleOneTap) {
            return;
        }
        var prompt = function() {
            Promise.all(/* import() */[__webpack_require__.e(6198), __webpack_require__.e(1878)]).then(__webpack_require__.bind(__webpack_require__, 91878)).then(function(param) {
                var promptGoogleOneTap = param.promptGoogleOneTap;
                promptGoogleOneTap("cosmos-".concat(page), function(redirectTo) {
                    onSuccess && onSuccess();
                    if (redirectTo) {
                        window.location.assign(redirectTo);
                    } else {
                        refresh();
                    }
                }, trackEvent, trackError);
            });
        };
        var timer;
        if (delay) {
            timer = setTimeout(prompt, delay);
        } else {
            prompt();
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        authentication.state,
        isAfterLoad,
        delay
    ]);
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/schema/index.ts
var schema = __webpack_require__(22067);
;// CONCATENATED MODULE: ./src/pages/shared/LandingPageV2Layout.tsx















var getSeoBaseTags = function(fields) {
    var title = fields === null || fields === void 0 ? void 0 : fields.title;
    var metaDescription = fields === null || fields === void 0 ? void 0 : fields.metaDescription;
    var canonicalUrl = fields === null || fields === void 0 ? void 0 : fields.canonicalUrl;
    var robots = [];
    // only set these when they are explicitly set to false
    // otherwise assume indexing and follow should be allowed
    if ((fields === null || fields === void 0 ? void 0 : fields.index) === false) {
        robots.push("noindex");
    }
    if ((fields === null || fields === void 0 ? void 0 : fields.follow) === false) {
        robots.push("nofollow");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: title !== null && title !== void 0 ? title : "Opendoor | Sell your home the minute you’re ready."
            }, "title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: (0,faviconPath/* default */.Z)({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            metaDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description") : null,
            canonicalUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robots.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: robots.join(",")
            }, "robots") : null
        ]
    });
};
var getOpenGraphTags = function(openGraphFields) {
    var url = openGraphFields.url, type = openGraphFields.type, title = openGraphFields.title, description = openGraphFields.description, image = openGraphFields.image, siteName = openGraphFields.siteName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type
            }, "og:type"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: url
            }, "og:url"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: image
            }, "og:image"),
            ",",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:site_name",
                content: siteName
            }, "og:site_name")
        ]
    });
};
var getJobPostingSchemaFromLoaderData = function(idToLoaderData) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(idToLoaderData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var loaderData = _step.value;
            if (loaderData === null || loaderData === void 0 ? void 0 : loaderData.jobPostingSchema) {
                return loaderData.jobPostingSchema;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var getLandingpageV2ServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, pageNum, slug, props, showModal, excludedSlugs, modalProps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = context.params) === null || ref === void 0 ? void 0 : ref.slug)) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageNum = 1;
                    if (context.query.page) {
                        pageNum = parseInt(context.query.page);
                    }
                    if (pageNum < 1) pageNum = 1;
                    slug = "";
                    // if slug is a string and not an array
                    if (typeof context.query.slug === "string") {
                        slug = context.query.slug;
                    } else if (Array.isArray(context.query.slug)) {
                        slug = context.query.slug.join("/");
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,cms/* fetchLandingPageV2BySlug */.AL)({
                            slug: slug,
                            requestUrl: context.resolvedUrl,
                            pageNum: pageNum,
                            locale: "en-US"
                        })
                    ];
                case 2:
                    props = _state.sent();
                    if (!props) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    // check if the page is set to public, and reject if appropriate
                    // this is intended to block non-public pages from being directly accessed by users,
                    // while still letting them be used in experiments as treatments
                    if (context.query.public && props.public === false) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    showModal = false;
                    excludedSlugs = [
                        "builder",
                        "agent",
                        "real-estate",
                        "homepage",
                        "login",
                        "register",
                        "reset-password",
                        "calculator",
                        "careers",
                        "safety",
                        "privacy"
                    ];
                    if (!excludedSlugs.every(function(excluded) {
                        return !slug.includes(excluded);
                    })) return [
                        3,
                        4
                    ];
                    showModal = true;
                    return [
                        4,
                        (0,cms/* getCashOfferModal */.Mq)()
                    ];
                case 3:
                    modalProps = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                modalFields: showModal && modalProps ? {
                                    title: modalProps.fields.title,
                                    description: modalProps.fields.description,
                                    analyticsId: modalProps.fields.analyticsId
                                } : null,
                                showModal: !!(showModal && modalProps)
                            })
                        }
                    ];
                case 5:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLandingpageV2ServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var LandingPageV2Layout = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    usePromptGoogleOneTap("landing-pages-v2-".concat(props.fields.slug), undefined, props.hideGoogleOneTap);
    var contextualData = {
        landingPageSlug: props.fields.slug
    };
    var fields = props.fields;
    var isTreatmentHeader = (ref = fields.body) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.some(function(node) {
        var ref, ref1, ref2;
        return (0,constants/* isTreatmentAnalyticsId */.Zl)((ref = node.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.analyticsId);
    });
    var imagePreloads = (0,preloads/* getContentPageImagePreloads */.Z)(props.idToLoaderData);
    var jobPostingSchema = getJobPostingSchemaFromLoaderData(props.idToLoaderData);
    var openGraphFields = (ref2 = props.fields.openGraph) === null || ref2 === void 0 ? void 0 : ref2.fields;
    var appleStatusBarColor = props.fields.slug === "homepage-syw-v2-home-guide" ? "black" : "default";
    var shouldIncludeTrustpilot = (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : ref3.shouldShowTrustpilotReviews;
    // Check if this is a market page (slug format: landing-pages-v2/market-[market])
    var isMarketPage = props.fields.slug.startsWith("landing-pages-v2/market-");
    // Convert Contentful slug to public URL format for markdown alternate link
    var publicSlug = isMarketPage ? props.fields.slug.replace(/^landing-pages-v2\/market-/, "/sell/") : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(observability_slim/* AddContextualData */.up, {
        data: contextualData,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    getSeoBaseTags((ref4 = props.fields.seoBase) === null || ref4 === void 0 ? void 0 : ref4.fields),
                    openGraphFields && getOpenGraphTags(openGraphFields),
                    isMarketPage && publicSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        id: "markdown-alternate",
                        rel: "alternate",
                        type: "text/markdown",
                        href: "".concat(publicSlug, ".md")
                    }, "markdown-alternate"),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "apple-mobile-web-app-status-bar-style",
                        content: appleStatusBarColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(schema/* HOMEPAGE_SCHEMA */.B)
                        }
                    }),
                    props.fields.jsonLdSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(props.fields.jsonLdSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    jobPostingSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(jobPostingSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    shouldIncludeTrustpilot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "text/javascript",
                        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                        async: true
                    }),
                    imagePreloads.map(function(h) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                            rel: "preload",
                            as: "image",
                            href: h.fallbackSrc,
                            media: h.media,
                            imageSrcSet: h.srcSet,
                            fetchPriority: "high"
                        }, h.key);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* default */.Z, {
                header: (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : ref5.header,
                slug: "/".concat((ref6 = props.fields) === null || ref6 === void 0 ? void 0 : ref6.slug),
                footer: (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : ref7.footer,
                showModal: props.showModal,
                modalTitle: (ref8 = props.modalFields) === null || ref8 === void 0 ? void 0 : ref8.title,
                modalDescription: (ref9 = props.modalFields) === null || ref9 === void 0 ? void 0 : ref9.description,
                modalAnalyticsId: (ref10 = props.modalFields) === null || ref10 === void 0 ? void 0 : ref10.analyticsId,
                extraLegalText: (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : ref11.extraLegalText,
                showEligibilityLegal: (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : ref12.showEligibilityLegal,
                showCustomerTestimonialLegal: (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : ref13.showCustomerTestimonialLegal,
                showThePdpCopyrightLegal: (ref14 = props.fields) === null || ref14 === void 0 ? void 0 : ref14.showThePdpCopyrightLegal,
                showPromotionLegal: (ref15 = props.fields) === null || ref15 === void 0 ? void 0 : ref15.showPromotionLegal,
                headerVariant: isTreatmentHeader ? "treatment" : undefined,
                children: props.children
            })
        ]
    });
};
/* harmony default export */ var shared_LandingPageV2Layout = (LandingPageV2Layout);


/***/ }),

/***/ 22067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ HOMEPAGE_SCHEMA; },
/* harmony export */   "z": function() { return /* binding */ buildJobPostingSchema; }
/* harmony export */ });
var HOMEPAGE_SCHEMA = {
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Opendoor Labs, Inc.",
    alternateName: "Opendoor",
    url: "https://www.opendoor.com",
    contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-888-352-7075",
        contactType: "Customer Service"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: "San Francisco",
        addressCountry: "USA",
        postalCode: "94104",
        streetAddress: "1 Post St, Fl 11"
    },
    logo: "https://www.opendoor.com/w/wp-content/uploads/2019/04/Opendoor-Logo.jpg",
    sameAs: [
        "https://www.facebook.com/OpendoorHQ",
        "https://twitter.com/opendoor",
        "https://www.youtube.com/channel/UCKKVV4bx18EtclsdNOFzWBw",
        "https://www.linkedin.com/company/opendoor-com",
        "https://www.pinterest.com/opendoorhq",
        "https://en.wikipedia.org/wiki/Opendoor", 
    ]
};
var buildJobPostingSchema = function(job) {
    var schema = {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: job.title,
        description: job.content,
        datePosted: job.first_published,
        hiringOrganization: {
            "@type": "Organization",
            name: "Opendoor",
            sameAs: "https://www.opendoor.com",
            logo: HOMEPAGE_SCHEMA.logo
        },
        jobLocation: {
            "@type": "Place",
            address: job.location.name
        },
        jobLocationType: job.location.name.toLowerCase().includes("remote") ? "TELECOMMUTE" : undefined,
        applicantLocationRequirements: job.location.name.toLowerCase().includes("remote") ? [
            {
                "@type": "Country",
                name: "US"
            },
            {
                "@type": "Country",
                name: "Canada"
            }, 
        ] : undefined
    };
    // Include baseSalary/employmentType from metadata if Greenhouse is configured with structured fields
    if (job.metadata) {
        var salaryMeta = job.metadata.find(function(m) {
            return [
                "salary_range",
                "salary",
                "compensation"
            ].includes(m.name.toLowerCase());
        });
        var employmentMeta = job.metadata.find(function(m) {
            return [
                "employment_type",
                "employment type"
            ].includes(m.name.toLowerCase());
        });
        if (salaryMeta === null || salaryMeta === void 0 ? void 0 : salaryMeta.value) schema.baseSalary = salaryMeta.value;
        if (employmentMeta === null || employmentMeta === void 0 ? void 0 : employmentMeta.value) schema.employmentType = employmentMeta.value;
    }
    // Remove undefined values
    return JSON.parse(JSON.stringify(schema));
};



/***/ }),

/***/ 39730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"GlassHeader_headerBar__WANyz","signInButton":"GlassHeader_signInButton__EhKrI","navLink":"GlassHeader_navLink__zD3Vq","flyoutLink":"GlassHeader_flyoutLink__GK5Et"};

/***/ })

}]);